import React, { useEffect, useState } from "react";
import { GithubIcon_Dark, RepoIcon } from "../../Data/Icons";

const LatestRepo = () => {
  const [repos, setRepos] = useState();
  const gridLimit = 6;
  const [isShowMore, setShowMore] = useState(false);
  useEffect(() => {
    fetch(
      "https://api.github.com/users/salmanprottoy/repos?sort=updated&direction=desc"
    )
      .then((reponse) => reponse.json())
      .then((data) => setRepos(data));
  }, []);
  return (
    <section className="projects">
      <h2>My latest repositories</h2>
      <ul className="projects__grid">
        {!repos
          ? "loading.."
          : isShowMore
          ? repos.map((repo) => (
              <li className="repo">
                <div className="repo__inner">
                  <div className="repo__top">
                    <div className="repo__icon">{RepoIcon}</div>
                    <div className="repo__links">
                      <a
                        href={repo.html_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        {GithubIcon_Dark}
                      </a>
                    </div>
                  </div>
                  <h3 className="repo__title">
                    <a href={repo.html_url}>{repo.name}</a>{" "}
                  </h3>
                  <div className="repo__description">
                    <p>{repo.description}</p>
                  </div>
                </div>
              </li>
            ))
          : repos.slice(0, gridLimit).map((repo) => (
              <li className="repo">
                <div className="repo__inner">
                  <div className="repo__top">
                    <div className="repo__icon">{RepoIcon}</div>
                    <div className="repo__links">
                      <a
                        href={repo.html_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        {GithubIcon_Dark}
                      </a>
                    </div>
                  </div>
                  <h3 className="repo__title">
                    <a
                      href={repo.html_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {repo.name}
                    </a>
                  </h3>
                  <div className="repo__description">
                    <p>{repo.description}</p>
                  </div>
                </div>
              </li>
            ))}
      </ul>
      <button className="ShowButton" onClick={() => setShowMore(!isShowMore)}>
        Show {!isShowMore ? "More" : "Less"}{" "}
      </button>
    </section>
  );
};

export default LatestRepo;
